import getPropertyValue from "@/mixins/getPropertyValue";
import moment from "moment";
import translate from "@/mixins/translate";

class LogRow {
  constructor(time, text) {
    this.time = time
    this.text = text
  }
}

class LogUtilsClass {

  _setStore(store) {
    this.$store = store
  }

  _hasLocation(entity) {
    return !!getPropertyValue(entity, 'gpsLatLng');
  }

  _timeDiff(start, end) {
    let startTime = moment(start, "HH:mm:ss");
    let endTime = moment(end, "HH:mm:ss");

    let diff = endTime.diff(startTime);
    return moment.utc(diff).format("HH:mm:ss")
  }

  _isTimePassed(time) {
    let currentTime = moment(this.virtualTime(), "HH:mm:ss");
    let testedTime = moment(time, "HH:mm:ss");

    let diff = currentTime.diff(testedTime);
    return diff > 0;
  }

  _getCrewCallSign(crewId, entities) {
    const crew = entities[crewId];
    return crew ? getPropertyValue(crew, 'volaciZnak') : "";
  }

  _getHospitalName(hospitalId, entities) {
    const hospital = entities[hospitalId];
    return hospital ? getPropertyValue(hospital, 'name') : "";
  }

  _eventOrder(event) {
    return ' #' + event.properties.cisloVyzvy.value
  }

  _createLogRowGeneric(event, time, created, i18nKey, log, includeEventId) {
    if (time) {
      log.push(new LogRow(time, time + " [+" + this._timeDiff(created, time) + "]: " + translate('Log.' + i18nKey)))
      log.push(new LogRow(time, `${time} [+${this._timeDiff(created, time)}]${includeEventId ? this._eventOrder(event) : ''} ${translate(`Log.${i18nKey}`)}`))
    }
  }

  _createLogRowCrew(event, times, created, i18nKey, log, entities, includeEventId) {
    if (times) {
      for (const t of times) {
        if (this._isTimePassed(t.time)) {
          log.push(new LogRow(
            t.time,
            `${t.time} [+${this._timeDiff(created, t.time)}]:${includeEventId ? this._eventOrder(event) : ''} ${translate(`Log.${i18nKey}`)}` +
            ` (#${this._getCrewCallSign(t.crewId, entities)}` +
            `${t.hospitalId ? (", " + this._getHospitalName(t.hospitalId, entities)) : ""}` +
            `${t.wardName ? (", " + t.wardName) : ""}` +
            `)`
          ))
        }
      }
    }
  }

  // === these methods below are kinda useless but im lazy to refactor and inline them...
  timeReady(entity) {
    return getPropertyValue(entity, 'readyRelativeTimeStr');
  }

  timeSummons(entity) {
    return getPropertyValue(entity, 'summonRelativeTimesStr');
  }

  timeDepartureFromBases(entity) {
    return getPropertyValue(entity, 'departureFromBaseRelativeTimesStr');
  }

  timeCrewArrives(entity) {
    return getPropertyValue(entity, 'crewArriveRelativeTimesStr');
  }

  timeCrewDepartureToHospitals(entity) {
    return getPropertyValue(entity, 'crewDepartureToHospitalRelativeTimesStr');
  }

  timeCrewHandoverInHospitals(entity) {
    return getPropertyValue(entity, 'crewHandoverInHospitalRelativeTimesStr');
  }

  timeRecallFromEvents(entity) {
    return getPropertyValue(entity, 'recallFromEventRelativeTimesStr');
  }

  timeArchive(entity) {
    return getPropertyValue(entity, 'archiveRelativeTimeStr');
  }

  timeForward(entity) {
    return getPropertyValue(entity, 'forwardRelativeTimeStr');
  }

  timeCancel(entity) {
    return getPropertyValue(entity, 'cancelRelativeTimeStr');
  }

  timeWaitingFromCancel(entity) {
    return getPropertyValue(entity, 'waitingFromCancelRelativeTimeStr');
  }

  timeWaitingFromForward(entity) {
    return getPropertyValue(entity, 'waitingFromForwardRelativeTimeStr');
  }

  timeAssignedFromArchive(entity) {
    return getPropertyValue(entity, 'assignedFromArchiveRelativeTimeStr');
  }

  timeHospitalAssigned(entity) {
    return getPropertyValue(entity, 'assignedHospitalRelativeTimeStr');
  }

  timeWardAssigned(entity) {
    return getPropertyValue(entity, 'assignedWardRelativeTimeStr');
  }

  virtualTime() {
    return new moment(this.$store.state.time.time).utc().format('HH:mm:ss')
  }

  getLogForBase(base, entities) {
    const log = []
    const text = `${getPropertyValue(base, 'name')} (${getPropertyValue(base, 'abbreviation')})`
    log.push(new LogRow(undefined, text))

    const crews = getPropertyValue(base, 'posadky');
    for (let crewEntityId of crews) {
      const crew = entities[crewEntityId]
      let crewData = {
        id: getPropertyValue(crew, 'volaciZnak'),
        type: getPropertyValue(crew, 'type'),
        name: getPropertyValue(crew, 'name') || "",
        status: translate('crewCard.' + getPropertyValue(crew, 'status'), getPropertyValue(crew, 'status')),
        callNumber: getPropertyValue(crew, 'pocetVyjezdu')
      };
      const crewText = [crewData.id, crewData.type, crewData.name, crewData.status, crewData.callNumber]
      log.push(new LogRow(undefined, crewText))
    }
    return log
  }

  getLogForEvent(event, entities, includeEventId) {
    let log = [];
    // "Volání"
    let created = getPropertyValue(event, 'createdRelativeTimeStr');
    log.push(new LogRow(created, created + " [+00:00:00]: " + translate('Log.call')))


    // "Připravení události"
    this._createLogRowGeneric(event, this.timeReady(event), created, 'readyTime', log, includeEventId);

    // "Výzva VSK (#ID)"
    this._createLogRowCrew(event, this.timeSummons(event), created, 'summonTime', log, entities, includeEventId);

    // "Odjezd k události (#ID)"
    this._createLogRowCrew(event, this.timeDepartureFromBases(event), created, 'departure', log, entities, includeEventId);

    // "Příjezd k události (#ID)"
    this._createLogRowCrew(event, this.timeCrewArrives(event), created, 'arriveTime', log, entities, includeEventId);

    // "Odjezd do ZZ (#ID, Cílová nemocnice)"
    this._createLogRowCrew(event, this.timeCrewDepartureToHospitals(event), created, 'departureToHospitalTime', log, entities, includeEventId);

    // "Předání v ZZ (#ID, Cílové oddělení)"
    this._createLogRowCrew(event, this.timeCrewHandoverInHospitals(event), created, 'handoverInHospitalTime', log, entities, includeEventId);

    // "Odvolání (#ID)"
    this._createLogRowCrew(event, this.timeRecallFromEvents(event), created, 'recall', log, entities, includeEventId);

    // "Archivace události"
    this._createLogRowGeneric(event, this.timeArchive(event), created, 'targetDepartmentAssigned', log, includeEventId);

    // "Předání události"
    this._createLogRowGeneric(event, this.timeForward(event), created, 'eventHandover', log, includeEventId);

    // "Storno události"
    this._createLogRowGeneric(event, this.timeCancel(event), created, 'cancelEvent', log, includeEventId);

    // "Zrušení storna události"
    this._createLogRowGeneric(event, this.timeWaitingFromCancel(event), created, 'revertCancelEvent', log, includeEventId);

    // "Zrušení předání události"
    this._createLogRowGeneric(event, this.timeWaitingFromForward(event), created, 'cancelEventHandover', log, includeEventId);

    // "Zrušení archivace události"
    this._createLogRowGeneric(event, this.timeAssignedFromArchive(event), created, 'cancelEventArchiving', log, includeEventId);


    // "Nastavení ZZ (cíl)"
    if (this.timeHospitalAssigned(event)) {
      const time = this.timeHospitalAssigned(event)
      const hospitalId = getPropertyValue(event, 'nemocnice')
      const text = `${time} [+${this._timeDiff(created, time)}]: ${translate('Log.ZZSettings')} (${this._getHospitalName(hospitalId)})`
      log.push(new LogRow(time, text))
    }

    // Nastavení oddělení ZZ (cíl)
    if (this.timeWardAssigned(event)) {
      const time = this.timeWardAssigned(event);
      const ward = getPropertyValue(event, 'oddeleni')
      const text = `${time} [+${this._timeDiff(created, time)}]: ${translate('Log.targetDepartmentAssigned')} (${ward})`
      log.push(new LogRow(time, text))
    }

    log.sort((a, b) => {
      a.time.localeCompare(b.time)
    });

    return log;
  }
}

export const LogUtils = new LogUtilsClass()
